import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { fontSize } from '@css/styles'
import { FontNormal } from '@css/fonts'
import { darkRed, darkGray, black } from '@css/constants'

export const Form = styled('form')(css`
  margin: 16px auto;
  max-width: 275px;
`)

export const Title = styled('h2')<{ small?: boolean }>(props => css`
  ${FontNormal(600)};
  ${fontSize(24)};
  color: ${black};
  text-align: center;
  max-width: ${props.small ? '345px' : 'auto'};
  margin: 0 auto;
`)

export const SubTitle = styled('p')(css`
  ${FontNormal(600)};
  ${fontSize(16)};
  color: ${darkGray};
  font-weight: normal;
  margin: 16px auto;
  max-width: 300px;
  text-align: center;
`)

export const List = styled('ul')(css`
  list-style: none;
`)

export const ListItem = styled('li')(css`
  list-style: none;
  margin: 16px 0;
`)

export const BirthdateListItem = styled(ListItem)(css`
  > div {
    margin-bottom: 9px;
  }
`)

export const Label = styled('label')(css`
  ${FontNormal(600)};
  ${fontSize(14)};
  font-style: normal;
  margin-bottom: 4px;
  display: inline-block;
`)

export const ErrorText = styled('div')(css`
  ${FontNormal(600)};
  color: ${darkRed};
  text-align: center;
  margin-top: 6px;
`)

export const updateButtonStyles = css`
  margin-top: 10px;
  width: 100%;
`
